import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import Dashboard from '@/pages/Dashboard';
import InvoiceView from '@/pages/InvoiceView';
import InvoiceForm from '@/pages/InvoiceForm';
import { Toaster } from '@/components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/invoice/:invoiceNumber" element={<InvoiceView />} />
          <Route path="/create" element={<InvoiceForm mode="create" />} />
          <Route path="/edit/:invoiceNumber" element={<InvoiceForm mode="edit" />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;